import { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
/* import {
  isEmpty,
} from 'lodash'; */
import {
  API,
  AdCategoryHelper,
  Field2 as Field,
} from 'vibeguide';
import Grid from '@mui/material/Grid';

class Information extends PureComponent {
  /**
   * When a field is changed
   */
  onChange = (e) => {
    const {
      target: {
        name,
        value,
      },
    } = e;

    const {
      onUpdate,
    } = this.props;

    onUpdate({
      [name]: value,
    });
  };

  /**
   * When the message type field is changed

  onChangeType = (e) => {
    const {
      target: {
        name,
        value,
      },
    } = e;

    const {
      type,
      onUpdate,
    } = this.props;

    const {
      ADMIN_COMPANY_ID: adminCompanyId,
    } = process.env;

    const data = {
      [name]: value,
      advertiserId: '',
      advertiserName: '',
    };

    if (value === 'air' || value === 'spec') {
      // Air Check, Spec Spot force location to Vibenomics ACAF
      // Force company to admin company
      data.companyId = adminCompanyId;
      data.companyName = 'Vibenomics, Inc.';

      data.startDate = '';
      data.endDate = '';
      data.locations = [{
        companyId: adminCompanyId,
        locationId: '*',
      }];
      data.locationsData = {
        companies: [{
          _id: adminCompanyId,
          locations: [],
          locationCount: '*',
        }],
        locations: [],
      };
      data.messageLists = [];
      data.messageBlocks = [];
    } else if (type === 'air' || type === 'spec') {
      // switching from ad (upload), air, or spec to not air, or spec, clear locations
      data.locations = [];
      data.locationsData = { companies: [], locations: [] };
    }

    if (value !== 'ad' || value !== 'ext-ad') {
      // If the previous type was ad, hide the selector
      // Remove the advertiser if one was selected
      data.advertiserId = '';
      data.advertiserName = '';
    }

    // if (value !== 'ad' || value !== 'ext-ad') {
    //   // If the previous type was ad, empty the company
    //   data.companyId = '';
    //   data.companyName = '';
    // }

    data.file = undefined;

    onUpdate(data);
  };
     */

  /**
   * When the tag field is changed
   */
  onChangeTag = (data) => {
    const {
      onUpdate,
    } = this.props;

    onUpdate(data);
  };

  onChangeDropdown = ({
    name,
    value,
    // data,
  }) => {
    const {
      onUpdate,
    } = this.props;

    onUpdate({
      [name]: value,
    });
  };

  /**
   * When the company field is changed
   */
  onSetCompany = ({
    id: companyId,
    value: companyName,
  }) => {
    const {
      type,
      mediaFormat,
      companyId: currCompanyId,
      tags,
      onUpdate,
    } = this.props;

    const data = !companyId
      ? {
        allLocations: false,
        locations: [],
        locationsData: {
          companies: [],
          locations: [],
        },
        tags: currCompanyId !== companyId
          ? tags.filter(tag => tag.type === 'admin')
          : tags,
      }
      : {};

    // force ACAF locations if an external ad request
    if (type === 'ext-ad' && mediaFormat === 'audio') {
      data.locations = [{
        companyId,
        locationId: '*',
      }];

      data.locationsData = {
        companies: [{
          _id: companyId,
          name: companyName,
          locations: [],
          locationCount: '*',
        }],
        locations: [],
      };
    }

    onUpdate({
      companyId,
      companyName,
      ...data,
    });
  };

  /**
   * When the advertiser field is changed
   */
  onChangeAdvertiser = (data) => {
    const {
      onUpdate,
    } = this.props;

    const {
      id,
      value,
    } = data;

    const updateData = {
      advertiserName: value,
    };

    if (id) {
      updateData.advertiserId = id;
    }

    onUpdate(updateData);
  };

  isCompanyDisabled = () => {
    const {
      type,
      isNew,
      user,
    } = this.props;

    if (!isNew
      || user.accountType === 'partner'
      || (type === 'ad' || type === 'ext-ad' || type === 'air' || type === 'spec')
    ) {
      return true;
    }

    return false;
  };

  render() {
    const {
      user,
      name,
      type,
      companyId,
      companyName,
      partnerName,
      advertiserName,
      category,
      tags,
      voiceTalentId,
      approverType,
      disableInput,
      isNew,
      isCopy,
    } = this.props;

    // const {
    //  messageTypeOptions,
    // } = this.state;

    const isVoiceTalent = user.voiceTalent && user._id === voiceTalentId;
    const isPartnerUser = user.accountType === 'partner';
    const canSetCompany = user.sysAdmin;

    const isAd = type === 'ad' || type === 'ext-ad';
    const showPartner = !isNew && (isAd && user.can('admin.ism_admin'));
    const showCompany = !isAd && (canSetCompany || isVoiceTalent);
    const showAdSelector = isAd;

    return (
      <div className="Information">
        <Grid spacing={2} container>
          <Grid size={showCompany || showPartner ? 6 : 12}>
            <Field
              type="text"
              label="Message Request Name"
              name="name"
              placeholder="Message Request Name"
              value={name}
              tabIndex={4}
              disabled={disableInput}
              onChange={this.onChange}
              required
              autoFocus
            />
          </Grid>

          {showCompany && (
            <Grid size={6}>
              <Field
                type="company"
                label="Company"
                name="companyName"
                value={companyName}
                tabIndex={5}
                companyProps={{
                  companyId,
                  companyName,
                }}
                disabled={this.isCompanyDisabled()}
                onChange={this.onSetCompany}
                required
              />
            </Grid>
          )}

          {showPartner && (
            <Grid size={6}>
              <Field
                type="text"
                label="Partner"
                name="partnerName"
                value={partnerName}
                tabIndex={6}
                disabled
                required
              />
            </Grid>
          )}

          {!isVoiceTalent && (
            <>
              {/* <Grid size={6}>
                <Field
                  type={messageTypeOptions.length > 1
                    ? 'select'
                    : 'hidden'}
                  label="Type"
                  name="messageType"
                  value={type}
                  tabIndex={3}
                  options={messageTypeOptions}
                  disabled={disableInput || (!isNew && !isCopy)}
                  onChange={this.onChangeType}
                  required
                />
              </Grid> */}

              {showAdSelector && (
                <>
                  <Grid size={6}>
                    <Field
                      type="dropdown"
                      label="Advertiser"
                      name="advertiser"
                      value={advertiserName}
                      tabIndex={7}
                      dropdownProps={{
                        type: 'advertiser',
                        attr: 'name',
                        fetch: API.Advertiser.list,
                        create: API.Advertiser.create,
                        canCreate: user.can('advertiser.create'),
                        successMessage: 'ADVERTISER.CREATED',
                      }}
                      disabled={disableInput || (!isNew && !isCopy)}
                      onChange={this.onChangeAdvertiser}
                      required
                    />
                  </Grid>

                  <Grid size={12}>
                    <Field
                      type="dropdown"
                      label="Ad Category"
                      name="category"
                      value={category}
                      dropdownProps={{
                        type: 'category',
                        attr: 'value',
                        collection: AdCategoryHelper.list(),
                      }}
                      onChange={this.onChangeDropdown}
                      tabIndex={8}
                    />
                  </Grid>
                </>
              )}

              {(!isPartnerUser && approverType !== 'partner') && (
                <Grid size={12}>
                  <Field
                    type="tags"
                    label="Tags"
                    name="tags"
                    tagProps={{
                      companyId,
                      tags,
                      allowTypes: ['client', 'admin'],
                      showAs: 'list',
                      assign: user.can('message.assign_tag'),
                    }}
                    disabled={disableInput}
                    onChange={this.onChangeTag}
                    tabIndex={9}
                  />
                </Grid>
              )}
            </>
          )}
        </Grid>
      </div>
    );
  }
}

Information.propTypes = {
  name: PropTypes.string,
  type: PropTypes.string,
  companyId: PropTypes.string,
  companyName: PropTypes.string,
  partnerName: PropTypes.string,
  advertiserName: PropTypes.string,
  category: PropTypes.string,
  tags: PropTypes.arrayOf(PropTypes.object),
  voiceTalentId: PropTypes.string,
  disableInput: PropTypes.bool,
  isNew: PropTypes.bool,
  isCopy: PropTypes.bool,
  onUpdate: PropTypes.func,
};

Information.defaultProps = {
  name: '',
  type: 'std',
  companyId: '',
  companyName: '',
  partnerName: '',
  advertiserName: '',
  category: '',
  tags: {},
  voiceTalentId: '',
  disableInput: false,
  isNew: false,
  isCopy: false,
  onUpdate: () => {},
};

function mapStateToProps(state) {
  return {
    user: state.login.user,
  };
}

export default connect(mapStateToProps)(Information);
